import { render, staticRenderFns } from "./button.component.vue?vue&type=template&id=3874efa5"
import script from "./button.component.ts?vue&type=script&lang=ts&external"
export * from "./button.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports